import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/react-query";

/**
 * Função para listar as características de revenda (fetch).
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @param {string} idTipoRevenda - ID do tipo de revenda.
 * @returns {Promise<any>} - Retorna a resposta da API contendo os dados das características de revenda.
 *
 * A resposta é um array de objetos.
 */
export function fetchRevendaCaracteristicaListar({
  enabled,
  authToken,
  idTipoRevenda,
}: {
  enabled?: boolean;
  authToken: string;
  idTipoRevenda?: string;
}): any {
  const fetch = async (): Promise<any> => {
    const url = "/api/RevendaCaracteristica/ListarPorFiltro";
    const params = idTipoRevenda ? { idTipoRevenda } : {};
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.post(url, params, config);
    return response?.data?.data?.response;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-revenda-caracteristica-listar"],
    enabled: enabled ?? false,
    refetchOnWindowFocus: false,
  });

  return query;
}

/**
 * Função para listar as características de revenda.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @param {string} idTipoRevenda - ID do tipo de revenda.
 * @returns {Promise<any>} - Retorna a resposta da API contendo os dados das características de revenda.
 *
 * A resposta é um array de objetos.
 */
export const postRevendaCaracteristicaListar = async (
  authToken: string,
  idTipoRevenda?: string
): Promise<any> => {
  const url = "/api/RevendaCaracteristica/ListarPorFiltro";
  const params = idTipoRevenda ? { idTipoRevenda } : {};
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, params, config);
  return response?.data;
};
